import { Card, CardContent, cn } from '@crm/ui';
import { ChevronRight, TriangleAlert } from 'lucide-react';
import type { Pendencia } from '../readiness';

/**
 * O que falta antes de disparar, no lugar dos resultados. Uma campanha que
 * nunca saiu nao tem numero para mostrar, e a tela vazia fazia parecer que o
 * disparo aconteceu e nao rendeu nada.
 *
 * Cada linha leva ao passo que a resolve: apontar o problema sem apontar o
 * caminho e metade do recado.
 */
export function PendingNotice({
  pendencias,
  nomeDoPasso,
  onIr,
}: {
  pendencias: Pendencia[];
  nomeDoPasso: (passo: number) => string;
  onIr: (passo: number) => void;
}) {
  return (
    <Card variant="flush">
      <CardContent className="space-y-4 py-5">
        <div className="flex gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-500/15">
            <TriangleAlert className="h-4.5 w-4.5 text-amber-600 dark:text-amber-400" />
          </span>
          <div className="space-y-0.5">
            <p className="font-semibold">Falta pouco para disparar</p>
            <p className="text-sm text-muted-foreground">
              Os numeros aparecem depois do primeiro disparo. Resolva o que ficou pendente:
            </p>
          </div>
        </div>

        <ul className="divide-y divide-border overflow-hidden rounded-card border border-border">
          {pendencias.map((item, indice) => {
            const clicavel = item.passo !== null;

            return (
              <li key={item.texto}>
                <button
                  type="button"
                  disabled={!clicavel}
                  onClick={() => {
                    if (item.passo !== null) onIr(item.passo);
                  }}
                  className={cn(
                    'flex w-full items-center gap-3 px-3 py-3 text-left transition-colors',
                    clicavel ? 'hover:bg-muted' : 'cursor-default',
                  )}
                >
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-semibold text-muted-foreground">
                    {indice + 1}
                  </span>

                  <span className="min-w-0 flex-1 truncate text-sm">{item.texto}</span>

                  {clicavel && item.passo !== null ? (
                    <span className="flex shrink-0 items-center gap-1 text-xs text-muted-foreground">
                      {nomeDoPasso(item.passo)}
                      <ChevronRight className="h-3.5 w-3.5" />
                    </span>
                  ) : (
                    <span className="shrink-0 text-xs text-muted-foreground">aqui embaixo</span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </CardContent>
    </Card>
  );
}
